// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider_root__NT9_j","horizontal":"Divider_horizontal__kIiLi","vertical":"Divider_vertical__h04BK"};